import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { StatusPageComponent } from "../common/status-page/status-page.component";

/**
 * `/server-error` — Smart TOS couldn't serve the request. `?returnUrl=/path` makes "Try again" go back there;
 * without it, Try again reloads the app.
 */
@Component({
  selector: "app-server-error",
  standalone: true,
  imports: [StatusPageComponent],
  templateUrl: "./server-error.component.html",
  styleUrl: "./server-error.component.scss"
})
export class ServerErrorComponent {
  private readonly returnUrl: string | null;

  constructor(private router: Router, route: ActivatedRoute) {
    const url = route.snapshot.queryParamMap.get("returnUrl");
    // same-app paths only
    this.returnUrl = url && url.startsWith("/") && !url.startsWith("//") ? url : null;
  }

  tryAgain() {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      window.location.assign("/");
    }
  }

  goToHome() {
    this.router.navigate(["/"]);
  }
}
